export default "__VITE_ASSET__a3c70c1f__"